import axios from 'axios';

const ibgeRequestByUF = axios.create({
  baseURL: import.meta.env.REACT_APP_IBGE_URL,
});

export default ibgeRequestByUF;
